import styles from './styles.module.scss'
import { FormPartInterface } from '../../../interfaces'
import { useClaimData } from '../../../claimProvider'

export const CompleteSigned = (props: FormPartInterface) => {
    const { isActive } = props
    const claim = useClaimData()

    if (isActive !== 'complete') return <></>

    return (
        <div className={styles.container}>
            <h2 style={{ textAlign: 'center' }}>Thank you!</h2>
            <p className={styles.tagline}>
                Your hearing loss claim document has been signed.
                <br />
                <br />
                {claim?.clientEmail ? (
                    <>
                        A signed copy has been emailed to <strong>{claim.clientEmail}</strong> for your records.
                    </>
                ) : (
                    <>A signed copy has been emailed to you for your records.</>
                )}
                <br />
                <br />
                A member of the Sentinel Legal team will be in touch soon.
            </p>
        </div>
    )
}
